import { call, put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPcrIdSelector } from '../../home/selectors/getPcrId.selector'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { IPatientVitals } from '../store/vitals.types'
import { saveVitals, setState } from '../store/vitals.actions'
import { getPatientTimelineSelector } from '../../timeline/selectors/patientTimeline.selector'
import { ITimelineState } from '../../timeline/store/timeline.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setLastVitals() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsState: IPatientVitals = yield select(getPatientVitalsSelector)
  const timeLineItems: ITimelineState = yield select(getPatientTimelineSelector)
  const { filteredItems } = timeLineItems
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const vitalItems = pcrDoc.patient?.patientVitals
      if (vitalItems && vitalItems.length !== 0) {
        let lastVitalskey: string | undefined
        const timelineVitals = filteredItems?.filter(
          (item) => item.itemType === 'Vitals' && item.key !== vitalsState.key
        )
        if (timelineVitals && timelineVitals.length > 0) {
          lastVitalskey = timelineVitals[timelineVitals.length - 1].key
        }
        const prevVitalState = vitalItems.find((item) => item.key === lastVitalskey)
        let updatedVitalsState = { ...vitalsState }
        if (prevVitalState) {
          const excludedFields = [
            'key',
            'time',
            'date',
            'clientEventId',
            'vsAction',
            'isEkgImport',
            '__isRedirectedFrom',
          ]

          Object.keys(prevVitalState).forEach((key) => {
            if (typeof key === 'string' && !excludedFields.includes(key)) {
              const prevStateValue = prevVitalState[key as keyof typeof prevVitalState]
              if (prevStateValue !== undefined && key in vitalsState) {
                updatedVitalsState = { ...updatedVitalsState, [key]: prevStateValue }
              }
            }
          })
        }
        yield put(setState(updatedVitalsState))
        yield put(saveVitals())
      }
    } catch (e) {
      yield put(throwPcrException(`setLastVitals() error: ${e}`))
    }
  }
}

export function* setLastVitalsSaga() {
  yield takeLatest([VitalsConstants.SET_LAST_VITALS], performWithMutexHOG, setLastVitals)
}
